import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import useIsMobile from '../hooks/useIsMobile';
import './Footer.css';

function Footer() {
  // Détection Mobile (source unique de vérité, alignée sur le breakpoint Tailwind `md`)
  const isMobile = useIsMobile();

  // --- CONFIGURATION DES STYLES MOBILE (NOIR) ---
  
  // Conteneur : Transparent sur mobile
  const containerStyle = useMemo(() => isMobile ? {
    backgroundColor: 'transparent',
    background: 'transparent',
    border: 'none',
    boxShadow: 'none',
    paddingTop: '20px'
  } : {}, [isMobile]);

  // Textes courants : NOIR (0,0,0) avec opacité 85%
  const textStyle = useMemo(() => isMobile ? {
    color: 'rgba(0, 0, 0, 0.85)', 
    fontSize: '0.95rem',
    fontWeight: '500' 
  } : {}, [isMobile]);

  // Titres : NOIR PUR
  const titleStyle = useMemo(() => isMobile ? {
    color: '#000000', 
    marginBottom: '1rem',
    fontWeight: '700'
  } : {}, [isMobile]);

  // Liens : NOIR 85%
  const linkStyle = useMemo(() => isMobile ? {
     color: 'rgba(0, 0, 0, 0.85)',
     textDecoration: 'none',
     fontWeight: '500'
  } : {}, [isMobile]);

  return (
    <footer id="contact" style={containerStyle}>
      <div className="footer-content">
        
        <div className="footer-section">
          <h3 style={titleStyle}>À propos</h3>
          <p style={textStyle}>
            Studio créatif spécialisé en design et visualisation 3D, nous
            donnons vie à vos idées avec des rendus et animations sur-mesure.
          </p>
        </div>
        
        <div className="footer-section">
          <h3 style={titleStyle}>Liens Rapides</h3>
          <ul>
            <li><Link to="/" style={linkStyle}>Accueil</Link></li>
            <li><Link to="/services" style={linkStyle}>Services</Link></li>
            <li><Link to="/services#tarifs" style={linkStyle}>Tarifs</Link></li>
            <li><Link to="/work" style={linkStyle}>Réalisations</Link></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h3 style={titleStyle}>Contact</h3>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            <li style={textStyle}>Email : joevinsirach@gmail.com</li>
            <li style={textStyle}>Phone : +33 7 69 59 62 00</li>
          </ul>
        </div>
        
      </div>
      
      {/* Ligne de séparation noire légère sur mobile */}
      <div className="footer-bottom" style={{ 
          ...containerStyle, 
          borderTop: isMobile ? '1px solid rgba(0,0,0,0.1)' : undefined,
          marginTop: isMobile ? '20px' : undefined
        }}>
        <p style={textStyle}>© 2025 JSD Global Design. Tous droits réservés.</p>
      </div>
    </footer>
  );
}

export default Footer;
